export default __webpack_public_path__ + "static/media/calendar-placeholder.3ca33692.svg";